import React from 'react'
import { useStore } from 'stook'
import useQuery from '../../../../hooks/useQuery'
import { MS_LIST_TABS } from '../../../../config/index'
interface IListQuery {
  pageIndex: number
  curTab: string
}

const DEFAULT_TAB = 'today'

export default function useOrderListQuery() {
  const useQueryIns = useQuery()
  const tab = useQueryIns.get('tab') as string
  const tabInConfig = MS_LIST_TABS.find((tabItem) => tabItem.value === tab)

  const [orderListQuery, setOrderListQuery] = useStore<IListQuery>(
    'OrderListQuery',
    {
      pageIndex: 1,
      curTab: tabInConfig ? tab : DEFAULT_TAB,
    }
  )

  const updateTab = (tab: string) => {
    setOrderListQuery((state) => {
      state.curTab = tab
      state.pageIndex = 1
    })
  }

  const updatePage = (page: number) => {
    setOrderListQuery((state) => {
      state.pageIndex = page
    })
  }

  return {
    orderListQuery,
    updatePage,
    updateTab,
  }
}
